import React, { Component } from 'react';
import { connect } from 'react-redux';
import { session } from '../../../../services/session';
import { getClass } from '../../../../utils/component-helpers';
import Constants from '../../../../app.constants';

import { paymentsService } from '../../account/payments-service';

import Icon from '../../../ui/icon';

class NavItem extends Component {
  constructor(props) {
    super(props);

    this.state = {
      hover: false,
    };
  }

  hover() {
    this.setState(state => ({
      hover: !state.hover,
    }));
  }

  isSelected(path) {
    const { currentPath } = this.props;
    const itemPath = this.props.item.path;
    if (path) {
      return currentPath.endsWith(path); // subnavItem path
    }
    // On megatable under Insights subnav ie not on merchants table
    const notMerchTable =
      (!currentPath.endsWith('/merchants') || itemPath === '/analytics') &&
      currentPath.indexOf(itemPath) > -1;
    return currentPath.endsWith(itemPath) || notMerchTable;
  }

  subnavCollapsed() {
    return this.props.item.subnav && !this.props.item.subnavExpanded;
  }

  subnavExpanded() {
    if (!this.props.item.subnav) return false;
    return this.props.item.subnavExpanded;
  }

  render() {
    const { item } = this.props;
    const className = item.className || item.path.replace('/', '');
    let subnav;
    const isStagingPubTestUser =
      session.userId === 233638 && ['staging', 'local'].includes(Constants.ENV);
    const isReleasePubTestUser =
      [2458, 2464].includes(session.userId) && ['release'].includes(Constants.ENV);
    const isPubTestUser = isStagingPubTestUser || isReleasePubTestUser;

    const isProductResearch = isPubTestUser && ['/product-research'].includes(item.path);

    if (item.subnav) {
      subnav = (
        <ul className="subnav">
          {item.subnav
            // Exclude navItems when viewing allSites
            .filter(item => !(session.allSites && item.hiddenForAllSites))
            // Exclude navItem hidden via Launch Darkly
            .filter(
              navItem =>
                !navItem.flag ||
                (this.props.flags.hasOwnProperty(navItem.flag) &&
                  this.props.flags[navItem.flag] === navItem.flagValue),
            )
            // Exclude navItems under feature toggle
            .filter(item => {
              return isProductResearch || session.isAdminView ? true : !item.featureToggle;
            })
            // Exclude mobile-only nav items if on desktop
            .filter(item => (item.mobileOnly && this.props.isMobile) || !item.mobileOnly)
            // Exclude creator-only nav items if not creator
            .filter(item => (item.creatorOnly && session.publisher_type === 2) || !item.creatorOnly)
            .map((subnavItem, index) => {
              const dataPath = `${item.path}${subnavItem.path}`;
              const subnavClass = subnavItem.path.replace('/', '');
              const icon =
                subnavItem.path === '/payment-setup' &&
                this.props.accountLink &&
                paymentsService.showAlertIcon(this.props.accountLink) &&
                this.props.flags &&
                this.props.flags.billingFeatures ? (
                  <Icon iconName="filledAlert" size={15} />
                ) : null;

              return (
                <li
                  className={getClass(`subnav-item ${subnavClass}`, {
                    selected: this.isSelected(`${item.path}${subnavItem.path}`),
                  })}
                  key={index}
                  data-path={dataPath}
                  onClick={this.props.onSubnavItemClicked}
                >
                  {icon}
                  <div className="subnav-item-label">
                    {subnavItem.label}
                    {subnavItem.label === 'Create Narrativ Links' && (
                      <span className="mobile-new"> NEW</span>
                    )}
                  </div>
                </li>
              );
            })}
        </ul>
      );
    }

    const icon = item.icon ? <Icon iconName={item.icon} size={15} /> : null;

    if (
      !item.flag ||
      (item.flag &&
        this.props.flags.hasOwnProperty(item.flag) &&
        this.props.flags[item.flag] === item.flagValue)
    ) {
      return (
        <li
          className={getClass(`nav-item ${className}`, {
            hover: this.state.hover,
            expanded: this.subnavExpanded(),
            collapsed: this.subnavCollapsed(),
            selected: this.isSelected(),
            'no-subnav': !item.subnav,
          })}
          /* Bubble event up to be handled by NavSidebar */
          onClick={this.props.onNavItemClicked}
        >
          <div className="nav-item-inner">
            {icon}
            <span
              className="label"
              onMouseEnter={this.hover.bind(this)}
              onMouseLeave={this.hover.bind(this)}
            >
              {item.label}
              {item.label === 'Create Narrativ Links' && <span className="mobile-new"> NEW</span>}
              {item.label === 'Orders' && <span className="non-mobile-new"> New</span>}
              {item.label === 'Links' && <span className="non-mobile-new"> New </span>}
              {item.beta && <span className="beta">Beta</span>}
            </span>
          </div>
          {subnav}
        </li>
      );
    }

    return null;
  }
}

export default NavItem;
